export const initialState = {
	selectedRegulatoryStatus: undefined,
	selectedRegulatoryStatusChangesClone: undefined
};

export default initialState;
